const algoliaAppId = 'K7CDH81S2X'
const algoliaApiKey = 'b80e95005ec48f0544087d3de939f39d'
const productSearchIndex = 'product_search'
const recipeSearchIndex = 'recipe_search'
const faqSearchIndex = 'faq_search'
const productSearchSuggestionsIndex = 'product_search_query_suggestions'

export {
  algoliaAppId,
  algoliaApiKey,
  productSearchIndex,
  productSearchSuggestionsIndex,
  recipeSearchIndex,
  faqSearchIndex,
}
